import { TelemetryPageViewEvent } from '../../utilities/insights/models/telemetry-page-view-event';

export class PageViewEvent extends TelemetryPageViewEvent {
	constructor(params: PageViewEventParams) {
		super('page-view');
		this.page = params?.page;
	}
}

interface PageViewEventParams {
	page: string;
}
